import React from "react";
import ReactDOM from "react-dom/client";



import App from "./App";
import { installGlobalErrorReporting } from "./utils/errorReporter";

installGlobalErrorReporting();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// D-Works PWA 기본 등록
// 지금은 설치형 웹앱 기반만 잡고, 푸시 알림은 다음 단계에서 연결합니다.
// 캐시를 강하게 걸지 않아야 배포 후 오래된 화면이 남는 문제를 줄일 수 있습니다.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("D-Works service worker registered:", registration.scope);
      })
      .catch((error) => {
        console.warn("D-Works service worker registration failed:", error);
      });
  });
}
